import { Skeleton, Stack } from '@mui/material'

export const ProgramsOverviewSkeleton = () => (
  <Stack direction="row" justifyContent="space-between">
    <Stack>
      <Skeleton variant="text" width={100} />
      <Skeleton variant="text" width={80} />
    </Stack>
    <Skeleton variant="rectangular" width={50} height={50} />
  </Stack>
)
